export default function getActivitiesCSV(data, t, users) {
	let dataArr = [];
	data?.forEach((activity) =>
		dataArr.push([
			users?.find((u) => u?.id === activity?.uid)?.displayName,
			activity?.region,
			activity?.type,
			activity?.description,
			activity?.total,
			activity?.approved ? t?.approved : t?.pending,
			activity?.date,
			activity?.oldPersonName ? activity?.oldPersonName : "",
			activity?.link3010 ? activity?.link3010 : "",
		])
	);

	return [
		[
			t?.username,
			t?.region,
			t?.type,
			t?.description,
			t?.totalHours,
			t?.approved,
			t?.date,
			t?.oldPersonName,
			t?.link3010
		],
		...dataArr,
	];
}
